/* eslint-disable no-param-reassign */
import { createActionTypeReducer } from 'util/reducers'
import { buildId } from 'util/globalId'
import {
  queryIdToQuery,
  constructFolderItemQueryId,
} from 'ducks/searches/utils/query'
import { CHAT_PAGE } from 'subapps/chat/pages'
import { BUILD_FROM_WIDGETS } from '../actionTypes/collections'
import { SET_ITEMS_BYID } from '../actionTypes/items'
import { dedupeFolders } from '../utils'

const itemsByIdInitialState = {}

function isValidChatFolder(folder) {
  const { default: isDefault, conditions } = folder
  if (!isDefault) return false
  if (conditions.length === 1) {
    const { param, operator } = conditions[0]
    // We dont currently support the drafts folders in chat
    if (param === 'drafts' && operator === 'eq') return false
  }
  return true
}

export const itemsById = createActionTypeReducer(
  {
    [SET_ITEMS_BYID]: (_, { payload: { items = [] } }) => {
      return items.reduce((itemById, item) => {
        itemById[item.id] = item
        return itemById
      }, {})
    },
    [BUILD_FROM_WIDGETS]: (
      draftState,
      { payload: { widgets = [], folders = [] } }
    ) => {
      const validItems = []
      const uniqFolders = dedupeFolders(folders)
      widgets.forEach(widget => {
        let { id: widgetId } = widget
        widgetId = buildId('Widget', widgetId)
        uniqFolders.forEach(folder => {
          const {
            id: folderId,
            position,
            displayCountWhenInactive,
            name,
          } = folder
          const itemId = `${widgetId}_${folderId}`
          validItems.push(itemId)
          const itemQueryId = constructFolderItemQueryId({ widget, folder })
          if (!draftState[itemId] && isValidChatFolder(folder)) {
            draftState[itemId] = {
              id: itemId,
              name,
              groupId: null,
              collectionId: widgetId,
              position,
              displayCountWhenInactive,
              queryId: itemQueryId,
              linkTo: {
                type: CHAT_PAGE,
                payload: {},
                meta: {
                  query: queryIdToQuery(itemQueryId),
                },
              },
            }
          }
        })
      })
      Object.keys(draftState).forEach(itemId => {
        if (!validItems.includes(itemId)) {
          delete draftState[itemId]
        }
      })
      return draftState
    },
  },
  itemsByIdInitialState
)
